import templateUrl from "emun.report/job-scheduler/job-scheduler-log.htm";
import controller from "emun.report/job-scheduler/job-scheduler-log.controller";

export default {
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};